<template>
    <div class="indicators-container">
        <div class="diagnostics-header">
            <div class="header_name-container">
                <div class="name-icon">
                    <img :src="getPhotoUrl(getIndicators.info)" alt="" class="add-files_form_img_cropp">
                </div>
                <div class="name">
                    <p>ФИО</p>
                    <input v-model="getIndicators.info.fio" readonly type="text" name="patientName" id="patientName" placeholder="Введите текст">
                </div>
                <div class="name gender">
                    <p>Пол</p>
                    <input :value="getIndicators.info.gender === 0 ? 'Мужской' : 'Женский'" readonly type="text" name="patientName" id="patientName" placeholder="Введите текст">
                </div>
                <div class="name gender">
                    <p>Дата рождения</p>
                    <input :value="getIndicators.info.birthday | filterBirthday" readonly />
                </div>
                <div class="name">
                    <p>Возраст</p>
                    <input :value="getIndicators.info.episodeAge" readonly />
                </div>
            </div>
        </div>
        <div class="indicators">
            <h2>Показатели пациента</h2>

            <div class="indicators-body">
                <div class="body-warap">
                    <h3 class="mb-4">
                        Антропометрические показатели
                        <v-btn v-if="!getFlagReadonly" icon :loading="loadingAnthropometricIndicatorsVisible">
                            <v-icon
                                :title="`${ anthropometricIndicatorsVisible ? 'Скрыть' : 'Показать'} все Антропометрические показатели`"
                                @click="viewOrNot(
                                    'UpdateAnthropometricIndicatorsVisible',
                                    'anthropometricIndicatorsVisible',
                                    'anthropometricIndicators',
                                    'loadingAnthropometricIndicatorsVisible',
                                    'Антропометрические показатели'
                                )"
                                color="#4854FE"
                            >
                                {{ anthropometricIndicatorsVisible ? 'mdi-eye-off' : 'mdi-eye' }}
                            </v-icon>
                        </v-btn>
                    </h3>

                    <v-autocomplete
                        class="mb-6"
                        label=""
                        placeholder="Выберите показатель"
                        item-value="propertyId"
                        item-text="propertyName"
                        multiple
                        clearable
                        @change="getFilters({
                            nameLoad: 'loadAnthropometric',
                            nameUrl: 'getAnthropometricIndicators',
                            nameParams: 'paramsAnthropometric'
                        })"
                        outlined
                        hide-details
                        v-model="paramsAnthropometric.propertyIds"
                        :loading="loadListAnthropometric"
                        :items="listAnthropometric"
                    >
                        <!-- <template slot="append">
                            <v-icon @click.prevent="getFilters" class="pt-1">mdi-close</v-icon>
                            <v-icon class="pt-1">mdi-menu-down</v-icon>
                        </template> -->
                    </v-autocomplete>

                    <div class="body-item" v-for="(item, key) in getIndicators.anthropometricIndicators" :key="'A'+key">
                        <div class="switch" v-if="!getFlagReadonly">
                            <v-btn
                                :loading="item.loadVisible"
                                @click="switchIsVisibleOrPatalogy({ obj: item, url: 'DiaTest/AddOrUpdateAnthropometricIndicator' }, 'loadVisible', 'isVisible')"
                                class="btn-load__view"
                                height="46"
                                :title="item.isVisible ? 'Скрыть' : 'Показать'"
                            >
                                <v-icon> {{ !item.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                            </v-btn>
                        </div>
                        <div class="switch" v-if="!getFlagReadonly">
                            <v-btn
                                :loading="item.loadSpr"
                                :disabled="!item.isVisible || item.propertyName === 'ИМТ' || item.propertyName === 'ИМТ (М)' "
                                @click="getData(item, key, 'SprAnthropometricIndicator')"
                                class="custom-button"
                                :class="{
                                    'btn-load__edite': true,
                                    'btn-load__disabled': !item.isVisible
                                }"
                                height="46"
                                :title="item.edite ? 'Закрыть' : 'Редактировать'"
                            >
                                <v-icon> {{ item.edite ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                            </v-btn>
                        </div>
                        <div class="item-combo">
                            <p>Наименование</p>
                            <input :disabled="!item.isVisible" v-model="item.propertyName" readonly type="text">
                        </div>
                        <div class="item-combo">
                            <p>Значение</p>
                            <input
                                :disabled="!item.isVisible"
                                v-show="!item.edite"
                                :value="item.valueType == 0  ? item.avgValue : item.listValueName"
                                readonly
                                type="text"
                            >

                            <input
                                v-show="item.edite && item.valueType === 0"
                                v-model="item.avgValue"
                                :ref="`input-${item.id}${key}`"
                                type="number"
                                @input="save({ obj: item, url: 'DiaTest/AddOrUpdateAnthropometricIndicator' })"
                            >

                            <v-autocomplete
                                label=""
                                v-show="item.edite && item.valueType === 1"
                                outlined
                                hide-details
                                height="46"
                                :rules="[rules.required]"
                                :items="item.listValues"
                                :loading="item.loadSpr"
                                @change="save({ obj: item, url: 'DiaTest/AddOrUpdateAnthropometricIndicator' }); setListValue(item)"
                                :placeholder="item.loadSpr ? 'Данные подгружаются из справочника...' : 'Выбрать значение'"
                                :no-data-text="item.loadSpr ? 'Ждите, данные подгружаются из справочника...' : 'Отсутствуют данные'"
                                item-text="name"
                                item-value="id"
                                class="item-combo__select"
                                v-model="item.listValueId"
                            />
                        </div>
                        <div class="item-combo">
                            <p>Единица измерения</p>
                            <input :disabled="!item.isVisible" v-model="item.measurementName" readonly type="text">
                        </div>
                        <div class="switch">
                            <p>Патология</p>
                            <div class="switch-item">
                                <span>Нет</span>
                                <v-switch
                                    v-model="item.isPathology"
                                    disabled
                                    :loading="item.loadPatalogy"
                                    @change="switchIsVisibleOrPatalogy({ obj: item, url: 'DiaTest/AddOrUpdateAnthropometricIndicator' }, 'loadPatalogy', null)"
                                />
                                <span>Да</span>
                            </div>
                        </div>
                    </div>

                    <v-overlay :value="loadAnthropometric" absolute :opacity="0.1">
                        <v-progress-circular indeterminate size="64" />
                    </v-overlay>
                </div>
                <pagination-component
                    :pageSize="paramsAnthropometric.pageSize"
                    :currentPage="paramsAnthropometric.currentPage"
                    :totalRecords="paramsAnthropometric.totalRecords"
                    nameParams="paramsAnthropometric"
                    nameUrl="getAnthropometricIndicators"
                    nameLoad="loadAnthropometric"
                    @query="getFilters"
                />
            </div>

            <div class="indicators-body mt-10">
                <div class="body-warap">
                    <h3 class="mb-4">
                        Витальные показатели
                        <v-btn v-if="!getFlagReadonly" icon :loading="loadingVitalIndicatorsVisible">
                            <v-icon
                                :title="`${ vitalIndicatorsVisible ? 'Скрыть' : 'Показать'} все Витальные показатели`"
                                @click="viewOrNot(
                                    'UpdateVitalIndicatorsVisible',
                                    'vitalIndicatorsVisible',
                                    'vitalIndicators',
                                    'loadingVitalIndicatorsVisible',
                                    'Витальные показатели'
                                )"
                                color="#4854FE"
                            >
                                {{ vitalIndicatorsVisible ? 'mdi-eye-off' : 'mdi-eye' }}
                            </v-icon>
                        </v-btn>
                    </h3>

                    <v-autocomplete
                        class="mb-6"
                        label=""
                        clearable
                        placeholder="Выберите показатель"
                        item-value="propertyId"
                        item-text="propertyName"
                        multiple
                        @change="getFilters({
                            nameLoad: 'loadVital',
                            nameUrl: 'getVitalIndicators',
                            nameParams: 'paramsVital'
                        })"
                        outlined
                        hide-details
                        v-model="paramsVital.propertyIds"
                        :loading="loadListVital"
                        :items="listVital"
                    />

                    <div class="body-item" v-for="(item, key) in getIndicators.vitalIndicators" :key="'A'+key">
                        <div class="switch" v-if="!getFlagReadonly">
                            <v-btn
                                :loading="item.loadVisible"
                                @click="switchIsVisibleOrPatalogy({ obj: item, url: 'DiaTest/AddOrUpdateVitalIndicator' }, 'loadVisible', 'isVisible')"
                                class="btn-load__view"
                                height="46"
                                :title="item.isVisible ? 'Скрыть' : 'Показать'"
                            >
                                <v-icon> {{ !item.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                            </v-btn>
                        </div>
                        <div class="switch" v-if="!getFlagReadonly">
                            <v-btn
                                :loading="item.loadSpr"
                                :disabled="!item.isVisible"
                                @click="getData(item, key, 'SprVitalIndicator')"
                                class="custom-button"
                                :class="{
                                    'btn-load__edite': true,
                                    'btn-load__disabled': !item.isVisible
                                }"
                                height="46"
                                :title="item.edite ? 'Закрыть' : 'Редактировать'"
                            >
                                <v-icon> {{ item.edite ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                            </v-btn>
                        </div>
                        <div class="item-combo">
                            <p>Наименование</p>
                            <input :disabled="!item.isVisible" v-model="item.propertyName" readonly type="text">
                        </div>
                        <div class="item-combo">
                            <p>Значение</p>
                            <input :disabled="!item.isVisible" v-show="!item.edite && item.valueType === 0" :value="item.avgValue" readonly type="number">
                            <input :disabled="!item.isVisible" v-show="!item.edite && item.valueType === 1" :value="item.listValueName" readonly type="text">

                            <input
                                v-show="item.edite && item.valueType === 0"
                                v-model="item.avgValue"
                                :ref="`input-${item.id}${key}`"
                                type="number"
                                @input="save({ obj: item, url: 'DiaTest/AddOrUpdateVitalIndicator' })"
                            >

                            <v-autocomplete
                                label=""
                                v-show="item.edite && item.valueType === 1"
                                outlined
                                height="46"
                                hide-details
                                :rules="[rules.required]"
                                :items="item.listValues"
                                :loading="item.loadSpr"
                                @change="save({ obj: item, url: 'DiaTest/AddOrUpdateVitalIndicator' }); setListValue(item)"
                                :placeholder="item.loadSpr ? 'Данные подгружаются из справочника...' : 'Выбрать значение'"
                                :no-data-text="item.loadSpr ? 'Ждите, данные подгружаются из справочника...' : 'Отсутствуют данные'"
                                item-text="name"
                                item-value="id"
                                class="item-combo__select"
                                v-model="item.listValueId"
                            />
                        </div>
                        <div class="item-combo">
                            <p>Единица измерения</p>
                            <input :disabled="!item.isVisible" v-model="item.measurementName" readonly type="text">
                        </div>
                        <div class="switch">
                            <p>Патология</p>
                            <div class="switch-item">
                                <span>Нет</span>
                                <v-switch
                                    disabled
                                    v-model="item.isPathology"
                                    :loading="item.loadPatalogy"
                                    @change="switchIsVisibleOrPatalogy({ obj: item, url: 'DiaTest/AddOrUpdateVitalIndicator' }, 'loadPatalogy', null)"
                                />
                                <span>Да</span>
                            </div>
                        </div>
                    </div>

                    <v-overlay :value="loadVital" absolute :opacity="0.1">
                        <v-progress-circular indeterminate size="64" />
                    </v-overlay>
                </div>
                <pagination-component
                    :totalRecords="paramsVital.totalRecords"
                    nameParams="paramsVital"
                    nameUrl="getVitalIndicators"
                    nameLoad="loadVital"
                    @query="getFilters"
                />
            </div>
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import debounce from 'lodash.debounce';
import paginationComponent from '@/components/Pagination/index'

export default {
    name: 'Indicators',
    components: {
        TimeoutSnackbar,
        paginationComponent
    },
    computed: {
        ...mapGetters({
            apiImg: 'apiImg',
            apiGuide: 'apiGuide',
            getIndicators: 'createDiagnosticTest/getIndicators',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        }),
    },
    data() {
        return {
            anthropometricIndicatorsVisible: true,
            loadingAnthropometricIndicatorsVisible: false,
            vitalIndicatorsVisible: true,
            loadingVitalIndicatorsVisible: false,
            listAnthropometric: [],
            listVital: [],
            loadListAnthropometric: true,
            loadListVital: true,
            loadVital: true,
            loadAnthropometric: true,
            rules: {
                required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
                minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.'
            },
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            itemsGender: [
                { id: 0, name: 'Мужчина' },
                { id: 1, name: 'Женщина' }
            ],
            paramsAnthropometric: {
                propertyIds: [],
                pageSize: 5,
                currentPage: 0,
                totalRecords: 1
            },
            paramsVital: {
                propertyIds: [],
                pageSize: 5,
                currentPage: 0,
                totalRecords: 1
            }
        }
    },
    methods: {
        ...mapActions({
            saveInline: 'createDiagnosticTest/saveInline',
            getAnthropometricIndicators: 'createDiagnosticTest/getAnthropometricIndicators',
            getVitalIndicators: 'createDiagnosticTest/getVitalIndicators',
            getSprAntrOrVital: 'createDiagnosticTest/getSprAntrOrVital',
            UpdateIndicatorsVisible: 'createDiagnosticTest/UpdateIndicatorsVisible'
        }),
        ...mapMutations({
            addObject: 'createDiagnosticTest/addObject'
        }),
        getSpr(type, url, name, loading, params) {
            if(this[name].length > 0) {
                return;
            }

            this[loading] = true;

            return new Promise((resolve, reject) => {
                this.$http[type](`${this.apiUrl}${url}`, params ? params : undefined)
                    .then((res) => {
                        let data = type === 'post' ? res.data.data : (name === 'itemsEpisode' ? res.data.episodes : res.data);

                        this[name] = data;
                        this[loading] = false;
                        resolve(res)
                    })
                    .catch((error) => {
                        if(error) reject(error)
                    })
            })

        },
        save: debounce( function (obj) {
            this.saveInline(obj)
                .then((data) => {
                    if(data.propertyId === 'bb575ced-441e-40c3-8809-37722e33994e' || data.propertyId === '2c47724d-28c4-4c40-8e0e-e581694a9c21' || data.propertyId === 'd6b6ba21-386f-40eb-a00b-3878bd7c3412' || data.propertyId === 'd1400ace-be61-4563-8866-3fd1d21ac018' ){
                        this.loadAnthropometric = true;
                        this.getAnthropometricIndicators({ ...this.paramsAnthropometric, testId: this.$route.params.id })
                        .then((response) => {
                            this.anthropometricIndicatorsVisible = response.isVisible;
                            this.paramsAnthropometric.totalRecords = Math.ceil(response.totalRecords / this.paramsAnthropometric.pageSize);
                            this.loadAnthropometric = false;
                    });
                    }
                    obj.obj.isPathology = data.isPathology;
                    obj.obj.edite = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                });
        }, 1500),
        setListValue(item) {
            let listValue = item.listValues.find(x => x.id === item.listValueId);

            if (listValue) {
                item.listValueName = listValue.name;
            }
        },
        getData(item, index, url) {
            item.edite = !item.edite;

            this.$nextTick(() => {
                if(item.valueType === 1) {
                    if(item.edite) {
                        item.loadSpr = true;
                        // Список для значения
                        this.$http.get(`${this.apiGuide}api/${url}/GetListValues?propertyId=${item.propertyId}`)
                            .then((res) => {
                                this.$refs[`input-${item.id}${index}`][0].focus();
                                item.listValues = res.data;
                                item.loadSpr = false;
                            })
                    }
                } else {
                    this.$refs[`input-${item.id}${index}`][0].focus();
                }
            })
        },
        switchIsVisibleOrPatalogy(obj, nameLoad, nameVal) {
            obj.obj[nameLoad] = true;
            if(nameVal) obj.obj[nameVal] = !obj.obj[nameVal];

            this.saveInline(obj)
                .then(() => {
                    obj.obj[nameLoad] = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };

                    // Если при обновлении флага на просмотр у любого показателя
                    // блок "Антропометрические или Витальные показатели" скрыт, то мы меняем
                    // глобальный флаг на скрыть
                    if(!this.anthropometricIndicatorsVisible) this.anthropometricIndicatorsVisible = true
                    if(!this.vitalIndicatorsVisible) this.vitalIndicatorsVisible = true
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                })
        },
        getPhotoUrl(obj) {
            if (obj.logoUrl) {
                return `${this.apiImg}${obj.logoUrl}`;
            }

            if (obj.gender === 1) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (obj.gender === 2) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        getFilters(obj) {
            if(obj.pageSize) this[obj.nameParams].pageSize = obj.pageSize;
            if(obj.currentPage >= 0) this[obj.nameParams].currentPage = obj.currentPage;

            this[obj.nameLoad] = true;


            // console.log({
            //     pageSize: this[obj.nameParams].pageSize,
            //     propertyIds: this[obj.nameParams].propertyIds,
            //     currentPage: this[obj.nameParams].currentPage,
            //     testId: this.$route.params.id
            // });

            this[obj.nameUrl]({
                pageSize: this[obj.nameParams].pageSize,
                propertyIds: this[obj.nameParams].propertyIds,
                currentPage: this[obj.nameParams].currentPage,
                testId: this.$route.params.id
            })
            .then((response) => {
                this[obj.nameParams].totalRecords = Math.ceil(response.totalRecords / response.pageSize);
                this[obj.nameLoad] = false;
            })
        },
        viewOrNot(url, nameVisible, nameState, loadName, nameInfo) {
            this[loadName] = true;
            this[nameVisible] = !this[nameVisible];
            this.UpdateIndicatorsVisible({ url, nameState, testId: this.$route.params.id, visible: this[nameVisible] })
                .then(() => {
                    this[loadName] = false;
                    this.snackbar = { text: `${nameInfo}, изменения сохранены успешно!`, color: 'success', timeout: 3000, show: true };
                })
                .catch((error) => {
                    if(error) {
                        this[loadName] = false;
                        this.snackbar = { text: 'Ошибка, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                })
        }
    },
    created() {
        this.getSprAntrOrVital({ url: 'DiaTest/GetAnthropometricIndicators', testId: this.$route.params.id })
            .then((response) => {
                this.listAnthropometric = response;
                this.loadListAnthropometric = false;
            })

        this.getSprAntrOrVital({ url: 'DiaTest/GetVitalIndicators', testId: this.$route.params.id })
            .then((response) => {
                this.listVital = response;
                this.loadListVital = false;
            })

        this.getAnthropometricIndicators({ ...this.paramsAnthropometric, testId: this.$route.params.id })
            .then((response) => {
                this.anthropometricIndicatorsVisible = response.isVisible;
                this.paramsAnthropometric.totalRecords = Math.ceil(response.totalRecords / this.paramsAnthropometric.pageSize);
                this.loadAnthropometric = false;
            });

        this.getVitalIndicators({ ...this.paramsVital, testId: this.$route.params.id })
            .then((response) => {
                this.vitalIndicatorsVisible = response.isVisible;
                this.paramsVital.totalRecords = Math.ceil(response.totalRecords / this.paramsVital.pageSize);
                this.loadVital = false;
            });
    }
}
</script>
